exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mydata{min-height:8in;background:#fff}.mydata .mydata-edit-container{border:1px solid #ccc;padding:15px}.mydata .tab-container{list-style:none;margin:0;padding:0;border-bottom:5px solid #efefef;margin-bottom:10px}.mydata .tab-container .tab{display:inline-block;margin-right:1px}.mydata .tab-container .tab a{display:inline-block;padding:8px 9pt 7px;font-weight:500;text-align:center;border-radius:5px 5px 0 0;color:#333;text-decoration:none}.mydata .tab-body,.mydata .tab-container .tab a.active,.mydata .tab-container .tab a:hover{background:#efefef}.mydata .tab-body{position:relative;padding-top:10px;margin-bottom:10px}.mydata .tab-body .action{position:absolute;right:10px;background-color:transparent;z-index:2}.mydata .form-control{color:#333}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Foundation/screens/MyData/style.css
 ** module id = 1446
 ** module chunks = 10
 **/